import { Close } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import React from "react";

interface TooltipContentProps {
  title: string;
  content: string | React.ReactNode;
  onClose?: () => void;
  onBack?: () => void;
  onNext?: () => void;
  color?: string;
  nextText?: string;
}

const TooltipContent: React.FC<TooltipContentProps> = (props) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "5px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        <Typography
          color={props.color}
          variant="h6"
          fontSize={"14px"}
          fontWeight={700}
          lineHeight={"normal"}
        >
          {props.title}
        </Typography>

        <Close
          sx={{
            fontSize: "13px",
            cursor: "pointer",
          }}
          onClick={props.onClose}
        />
      </Box>
      <Typography
        color={props.color}
        variant="h6"
        fontSize={"14px"}
        fontWeight={400}
        lineHeight={"normal"}
      >
        {props.content}
      </Typography>

      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <Button
          sx={{
            color: props.color,
            textDecoration: "underline",
            padding: "0",
            minWidth: "fit-content",
            fontSize: "14px",
          }}
          onClick={props.onBack}
        >
          Back
        </Button>
        <Button
          sx={{
            color: props.color,
            textDecoration: "underline",
            padding: "0",
            minWidth: "fit-content",
            fontSize: "14px",
            marginLeft: "15px",
          }}
          onClick={props.onNext}
        >
          {props.nextText ?? "Next"}
        </Button>
      </Box>
    </Box>
  );
};

export default TooltipContent;
